import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import {
  MAXIMUM_NUMBER_OF_SEARCH_RESULTS,
  MINIMUM_NUMBER_OF_SEARCH_RESULTS,
} from '@/modules/Profile/constants'
import type { FetchTravelPreferencesPublicSuccessResponse } from '@/modules/Profile/types/api/response/travelPreferences'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export const QUERY_KEY = 'travel-preferences-public'
const ENDPOINT = '/TravelPreferences/Public'

function fetchTravelPreferencesPublic() {
  return axiosInstance
    .get<FetchTravelPreferencesPublicSuccessResponse>(ENDPOINT, {})
    .then((response) => {
      response.data.data.travelPrefs.Other = [
        {
          type: 'minimumSwapAmount',
          name: 'profile.minimumSwapAmount',
          inputType: 'number',
        },
        {
          type: 'numberOfSearchResult',
          name: 'profile.numberOfSearchResult',
          inputType: 'counter',
          min: MINIMUM_NUMBER_OF_SEARCH_RESULTS,
          max: MAXIMUM_NUMBER_OF_SEARCH_RESULTS,
        },
        {
          type: 'dontDisturbStartTime',
          name: 'profile.dontDisturbStartTime',
          inputType: 'time-picker',
        },
        {
          type: 'dontDisturbEndTime',
          name: 'profile.dontDisturbEndTime',
          inputType: 'time-picker',
        },
      ]

      // Ensure 'hotelRating' is the last preference in 'Hotel preferences'
      const hotelPreferences =
        response.data?.data?.travelPrefs?.['Hotel preferences']
      if (hotelPreferences) {
        response.data.data.travelPrefs['Hotel preferences'] = [
          ...hotelPreferences.filter(({ type }) => type !== 'hotelRating'),
          ...hotelPreferences.filter(({ type }) => type === 'hotelRating'),
        ]
      }

      return response.data
    })
}

export function useTravelPreferencesPublicQuery(
  options?: UseQueryOptions<
    Awaited<ReturnType<typeof fetchTravelPreferencesPublic>>
  >
) {
  return useQuery({
    queryFn: fetchTravelPreferencesPublic,
    queryKey: [QUERY_KEY],
    ...options,
  })
}
